export const RECENT_NOTIFICATION_DEFAULT_SORT = 'createdAt:DESC';
export const RECENT_NOTIFICATION_LIMIT = 10;
export const NOTIFICATION_TYPE_APP = 'app';
